import SideBarTool from "@/commons/components/side-bar-tool";
import { Select, message } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PMaterial } from "@/commons/interface/speccommon/material";
import { MAJOR } from "@/commons/constants/major";
import { getMaterialsByprojectUuid } from "@/api/spec-common/material";
import { findLayersInProjectUuid, saveLayer } from "@/api/geometry/layer";
import genUUID from "@/commons/utils/gen-uuid";
import { Layer } from "@/commons/interface/geometry/layer";
import { bool3d, BoolSolidT, Circle, ExtrudeSolidT, JointPoint, LineType, ModelUtils, Point, Polygon, RevolveSolidT, SolidT, StraightLine } from "pytha";
import { graphicStore } from "@/commons/store/graphic-store";
import { ReactComponent as AssembleBlackSvg } from "@/commons/icons/panel-icon/assemble-black.svg";
import TnMessage from "@/commons/widget/message";
import { HVAC_SIGNAL } from "@/passets/hvac-engine/enums/hvac-signal";
import { HVAC_SUB_CONTROL } from "@/passets/hvac-engine/enums/hvac-sub-control";
import { HVAC_CTRL_TYPE } from "@/passets/hvac-engine/enums/hvac-control-type";
import { LayerType } from "@/commons/enums/layer-type";
import { HVAC_CONNECT, HVAC_CONNECT_TYPE } from "@/commons/enums/hvac-connect-type";
import { Vector3 } from "three";
import { HvacTunnelConnectT } from "@/passets/hvac-engine/models/HvacTunnelConnectT";
import TnInput from "@/commons/widget/input/tn-input";

/**
 * 暖通接头
 */
export default function HavcTunnelConnectPanel() {
    const { projectUuid, modelUuid } = useParams();
    const [materials, setMaterials] = useState<PMaterial[]>([]); // 材料列表
    const [selMaterial, setSelMaterial] = useState<PMaterial>(null);
    const [diameter, setDiameter] = useState<number>(null);    // 管径
    const [diameter2, setDiameter2] = useState<number>(null); // 管径2
    const [angle, setAngle] = useState<number>(null);  // 角度
    const [length, setLength] = useState<number>(null);    // 长度
    const [width, setWidth] = useState<number>(null);
    const [width2, setWidth2] = useState<number>(null);    // 宽度2
    const [thickness, setThickness] = useState<number>(null);
    const [type, setType] = useState<number>(HVAC_CONNECT.ROUND_DUCT_ELBOW); // 材料类型

    useEffect(() => {
        if (!projectUuid) return;
        getMaterialsByprojectUuid(projectUuid, MAJOR.HVAC).then(res => {
            if (res.status == 200) {
                let materials = res.data || [];
                setMaterials(materials);
            }
        }).catch(() => {
            message.error("获得材料列表失败")
        })
    }, [projectUuid])

    const onMaterialChange = (uuid: string) => {
        let material = materials.find(item => item.uuid == uuid);
        setSelMaterial(material);
    }

    // 点击了布置按钮
    const assemble = () => {
        if (selMaterial == null) {
            TnMessage.error("请选择材料");
            return;
        }
        if (!thickness) {
            message.warning("请输入壁厚");
            return;
        }
        let blockEntities
        let block
        let insertJointList: JointPoint[] = []
        switch (type) {
            case HVAC_CONNECT.ROUND_DUCT_ELBOW:
                if (!diameter) {
                    TnMessage.warning("管径不能为空");
                    return;
                }
                if (!angle) {
                    TnMessage.warning("角度不能为空");
                    return;
                }
                if (thickness >= diameter / 2) {
                    TnMessage.warning("壁厚过大");
                    return;
                }
                blockEntities = generateRoundElbowEntities(diameter, thickness, angle);
                console.log(blockEntities);
                // 获取圆管两个点
                let entityElbow = blockEntities[0] as RevolveSolidT
                let p1Elbow: Point = new Point(0, 0, 0)
                let p2Elbow: Point = p1Elbow.clone().rotate(entityElbow._geo.axis.origin, entityElbow._geo.axis.direction, entityElbow._geo.angle)

                let p1ElbowJoint: JointPoint = {
                    point: p1Elbow,
                    key: "basePoint",
                    normal: new Vector3(0, 0, -1),
                    axisX: new Vector3(1, 0, 0)
                }
                let midV = new Vector3(0, 0, 1)
                midV.applyAxisAngle(new Vector3(0, -1, 0), angle).normalize()
                let midX = new Vector3(0, 1, 0).cross(midV).normalize()
                let p2ElbowJoint: JointPoint = {
                    point: p2Elbow,
                    key: "rotatePoint",
                    normal: midV,
                    axisX: midX
                }
                insertJointList = [p1ElbowJoint, p2ElbowJoint]
                block = generateBlock(blockEntities, [...insertJointList], selMaterial.uuid);
                console.log(block);
                break;
            case HVAC_CONNECT.ROUND_DUCT_TTEE:
                if (!diameter) {
                    TnMessage.warning("管径不能为空");
                    return;
                }
                if (!diameter2) {
                    TnMessage.warning("管径2不能为空");
                    return;
                }
                if (!length) {
                    TnMessage.warning("长度不能为空");
                    return;
                }
                if (thickness >= diameter / 2 || thickness >= diameter2 / 2) {
                    message.warning("壁厚过大");
                    return;
                }
                blockEntities = generateRoundTTeeEntities(diameter, diameter2, length, thickness);
                let tteeP1 = new Vector3(0, 0, 0)
                let tteeP2 = new Vector3(length * 2 + diameter2, 0, 0)
                let tteeP3 = new Vector3(length + diameter2 / 2, -diameter - length, 0);

                let tteeP1Joint: JointPoint = {
                    key: "basePoint",
                    point: tteeP1,
                    normal: new Vector3(-1, 0, 0),
                    axisX: new Vector3(0, -1, 0)
                }

                let tteeP2Joint: JointPoint = {
                    key: "rightPoint",
                    point: tteeP2,
                    normal: new Vector3(1, 0, 0),
                    axisX: new Vector3(0, 1, 0)
                }

                let tteeP3Joint: JointPoint = {
                    key: "downPoint",
                    point: tteeP3,
                    normal: new Vector3(0, -1, 0),
                    axisX: new Vector3(1, 0, 0)
                }
                insertJointList = [tteeP1Joint, tteeP2Joint, tteeP3Joint]
                block = generateBlock(blockEntities, [...insertJointList], selMaterial.uuid);
                break;
            case HVAC_CONNECT.ROUND_DUCT_YTEE:
                // 圆管Y形三通
                if (!diameter) {
                    message.warning("管径1不能为空");
                    return;
                }
                if (!diameter2) {
                    message.warning("管径2不能为空");
                    return;
                }
                if (!length) {
                    message.warning("长度不能为空");
                    return;
                }
                if (thickness >= diameter / 2 || thickness >= diameter2 / 2) {
                    message.warning("壁厚过大");
                    return;
                }
                blockEntities = generateRoundYTeeEntities(diameter, diameter2, length, thickness);
                let tyeeP1 = new Vector3(0, 0, 0)
                let tyeeP2 = new Vector3(length * 2 + diameter2, 0, 0)
                let tyeeP3 = new Vector3(length + diameter2 / 2, 0, 0).add(new Vector3(1, -1, 0).normalize().multiplyScalar(diameter + length))

                let tyeeP1Joint: JointPoint = {
                    key: "basePoint",
                    point: tyeeP1,
                    normal: new Vector3(-1, 0, 0),
                    axisX: new Vector3(0, -1, 0)
                }

                let tyeeP2Joint: JointPoint = {
                    key: "rightPoint",
                    point: tyeeP2,
                    normal: new Vector3(1, 0, 0),
                    axisX: new Vector3(0, 1, 0)
                }

                let tyeeP3Joint: JointPoint = {
                    key: "downPoint",
                    point: tyeeP3,
                    normal: new Vector3(1, -1, 0).normalize(), axisX: new Vector3(1, 1, 0).normalize()
                }
                insertJointList = [tyeeP1Joint, tyeeP2Joint, tyeeP3Joint]
                block = generateBlock(blockEntities, [...insertJointList], selMaterial.uuid);
                break;
            case HVAC_CONNECT.RECTANGULAR_DUCT_ELBOW:
                // 矩形管弯头
                if (!length) {
                    message.warning("长度不能为空");
                    return;
                }
                if (!width) {
                    message.warning("宽度不能为空");
                    return;
                }
                if (!angle) {
                    message.warning("角度不能为空");
                    return;
                }
                if (thickness >= length / 2 || thickness >= width / 2) {
                    message.warning("壁厚过大");
                    return;
                }
                blockEntities = generateRectangularElbowEntities(length, width, thickness, angle);
                // 获取矩形管两个点
                let entityRElbow = blockEntities[0] as RevolveSolidT
                let p1RElbow: Point = new Point(0, 0, 0)
                let p2RElbow: Point = p1RElbow.clone().rotate(entityRElbow._geo.axis.origin, entityRElbow._geo.axis.direction, entityRElbow._geo.angle)

                let p1RElbowJoint: JointPoint = {
                    key: "basePoint",
                    point: p1RElbow,
                    normal: new Vector3(0, 0, -1),
                    axisX: new Vector3(1, 0, 0)
                }
                let midV1 = new Vector3(0, 0, 1)
                midV1.applyAxisAngle(new Vector3(0, -1, 0), angle).normalize()
                let midX1 = new Vector3(0, 1, 0).cross(midV1).normalize()
                let p2RElbowJoint: JointPoint = {
                    key: "rotatePoint",
                    point: p2RElbow,
                    normal: midV1,
                    axisX: midX1
                }
                insertJointList = [p1RElbowJoint, p2RElbowJoint]
                block = generateBlock(blockEntities, [...insertJointList], selMaterial.uuid);
                break;
            case HVAC_CONNECT.RECTANGULAR_DUCT_TTEE:
                // 矩形管T形三通
                if (!width) {
                    message.warning("宽度1不能为空");
                    return;
                }
                if (!width2) {
                    message.warning("宽度2不能为空");
                    return;
                }
                if (!length) {
                    message.warning("长度不能为空");
                    return;
                }
                if (thickness >= width / 2 || thickness >= width2 / 2) {
                    message.warning("壁厚过大");
                    return;
                }
                blockEntities = generateRectangularTTeeEntities(width, width2, length, thickness);
                let tteeDP1 = new Vector3(0, 0, 0)
                let tteeDP2 = new Vector3(length * 2 + width2, 0, 0)
                let tteeDP3 = new Vector3(length + width2 / 2, -width - length / 2, 0);

                let tteeDP1Joint: JointPoint = {
                    key: "basePoint",
                    point: tteeDP1,
                    normal: new Vector3(-1, 0, 0),
                    axisX: new Vector3(0, -1, 0)
                }

                let tteeDP2Joint: JointPoint = {
                    key: "rightPoint",
                    point: tteeDP2,
                    normal: new Vector3(1, 0, 0),
                    axisX: new Vector3(0, 1, 0)
                }

                let tteeDP3Joint: JointPoint = {
                    key: "downPoint",
                    point: tteeDP3,
                    normal: new Vector3(0, -1, 0),
                    axisX: new Vector3(1, 0, 0)
                }
                insertJointList = [tteeDP1Joint, tteeDP2Joint, tteeDP3Joint]
                block = generateBlock(blockEntities, [...insertJointList], selMaterial.uuid);
                break;
        }
        findLayersInProjectUuid(projectUuid, modelUuid).then(res => {
            let layers: Layer[] = res.data || [];
            let componentLayer = layers?.find(item => item?.type === LayerType.CONNECT);
            if (!!componentLayer) {
                // 存在一个图层为构件图层，绘制的图元都在该图层中
                handleAssemble(block, componentLayer.uuid);
            } else {
                // 不存在一个图层为构件图层，新建一个图层作为构件图层，绘制的图元都在该图层中
                let uuid = genUUID();
                let newLayer: Layer = {
                    uuid: uuid,
                    name: "接头",
                    color: "#000000",
                    lineWidth: 0.25,
                    lineType: LineType.BASE_LINE,
                    lock: false,
                    hidden: false,
                    projectUuid: projectUuid,
                    originLayer: false,
                    type: LayerType.CONNECT,
                };
                saveLayer(newLayer, projectUuid, modelUuid).then(res => {
                    if (res.status === 200) {
                        graphicStore.context.layerContext.addLayer(newLayer);
                        handleAssemble(block, newLayer.uuid);
                    }
                }).catch(err => {
                    message.error("无法置为构件图层");
                    console.log(err);
                })
            }
        })
    }

    const handleAssemble = (block: HvacTunnelConnectT, layerUuid: string) => {
        block.layerUuid = layerUuid;
        let data = {
            type: type,
            materialUuid: selMaterial,
            layerUuid: layerUuid,
            offset: 0,
        }
        if (!graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl
            || graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl.id !== HVAC_CTRL_TYPE.ADD_HVAC_TUNNEL_CONNECT) {
            // 激活布置构件的二级控制器
            graphicStore.extraContext.getCurrentViewEditor().cmdControl.activateSubCommandControl(HVAC_SUB_CONTROL.ADDHVACTUNNELCONNECTCONTROL.name);
        }
        graphicStore.extraContext.listeners.getSignal(HVAC_SIGNAL.initHvacTunnelConnectControl).dispatch(data, block);
    }

    // 生成圆管弯头
    const generateRoundElbowEntities = (diameter: number, thickness: number, angle: number) => {
        let outerCircle = new Circle(new Point(0, 0, 0), diameter / 2, false, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        let innerCircle = new Circle(new Point(0, 0, 0), diameter / 2 - thickness, false, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        let bottomFace = new Polygon();
        bottomFace.holes = [new Polygon([innerCircle], new Vector3(1, 0, 0), new Point(0, 0, 0))];
        bottomFace.set([outerCircle]);
        let axis = new StraightLine();
        axis.set(new Point(-diameter, 0, 0), new Vector3(0, -1, 0))
        let revolveSolid = new RevolveSolidT(bottomFace, axis, angle);
        return [revolveSolid];
    }

    // 生成圆管T形三通
    const generateRoundTTeeEntities = (diameter1: number, diameter2: number, shoulder: number, thickness: number) => {
        // 第一个圆柱
        let outerCircle = new Circle(new Point(0, 0, 0), diameter1 / 2, false, new Vector3(1, 0, 0), new Vector3(0, -1, 0));
        let solid1 = new ExtrudeSolidT(new Polygon([outerCircle]), new Vector3(1, 0, 0), diameter2 + 2 * shoulder);
        // 第三个圆柱
        let innerCircle = new Circle(new Point(0, 0, 0), diameter1 / 2 - thickness, false, new Vector3(1, 0, 0), new Vector3(0, -1, 0));
        let solid3 = new ExtrudeSolidT(new Polygon([innerCircle]), new Vector3(1, 0, 0), diameter2 + 2 * shoulder);
        // 第二个圆柱
        let outCircle = new Circle(new Point(shoulder + diameter2 / 2, 0, 0), diameter2 / 2, false, new Vector3(0, -1, 0).normalize(), new Vector3(-1, 0, 0).normalize());
        let solid2 = new ExtrudeSolidT(new Polygon([outCircle]), new Vector3(0, -1, 0), diameter1 + shoulder);
        // 第四个圆柱
        let inCircle = new Circle(new Point(shoulder + diameter2 / 2, 0, 0), diameter2 / 2 - thickness, false, new Vector3(0, -1, 0).normalize(), new Vector3(-1, 0, 0).normalize());
        let solid4 = new ExtrudeSolidT(new Polygon([inCircle]), new Vector3(0, -1, 0), diameter1 + shoulder);
        let result = (solid1 as SolidT)._geo.toBoolSolid();
        let boolSolid2 = (solid2 as SolidT)._geo.toBoolSolid();
        let boolSolid3 = (solid3 as SolidT)._geo.toBoolSolid();
        let boolSolid4 = (solid4 as SolidT)._geo.toBoolSolid();
        result = bool3d(result, boolSolid2, 2);
        result = bool3d(result, boolSolid3, 1);
        result = bool3d(result, boolSolid4, 1);
        let resultSolid = new BoolSolidT(result);
        return [resultSolid];
    }

    // 生成圆管Y形三通
    const generateRoundYTeeEntities = (diameter1: number, diameter2: number, shoulder: number, thickness: number) => {
        // 第一个圆柱
        let outerCircle = new Circle(new Point(0, 0, 0), diameter1 / 2, false, new Vector3(1, 0, 0), new Vector3(0, -1, 0));
        let solid1 = new ExtrudeSolidT(new Polygon([outerCircle]), new Vector3(1, 0, 0), diameter2 + 2 * shoulder);
        // 第三个圆柱
        let innerCircle = new Circle(new Point(0, 0, 0), diameter1 / 2 - thickness, false, new Vector3(1, 0, 0), new Vector3(0, -1, 0));
        let solid3 = new ExtrudeSolidT(new Polygon([innerCircle]), new Vector3(1, 0, 0), diameter2 + 2 * shoulder);
        // 第二个圆柱
        let outCircle = new Circle(new Point(shoulder + diameter2 / 2, 0, 0), diameter2 / 2, false, new Vector3(1, -1, 0).normalize(), new Vector3(-1, -1, 0).normalize());
        let solid2 = new ExtrudeSolidT(new Polygon([outCircle]), new Vector3(1, -1, 0), diameter1 + shoulder);
        // 第四个圆柱
        let inCircle = new Circle(new Point(shoulder + diameter2 / 2, 0, 0), diameter2 / 2 - thickness, false, new Vector3(1, -1, 0).normalize(), new Vector3(-1, -1, 0).normalize());
        let solid4 = new ExtrudeSolidT(new Polygon([inCircle]), new Vector3(1, -1, 0), diameter1 + shoulder);
        let result = (solid1 as SolidT)._geo.toBoolSolid();
        let boolSolid2 = (solid2 as SolidT)._geo.toBoolSolid();
        let boolSolid3 = (solid3 as SolidT)._geo.toBoolSolid();
        let boolSolid4 = (solid4 as SolidT)._geo.toBoolSolid();
        result = bool3d(result, boolSolid2, 2);
        result = bool3d(result, boolSolid3, 1);
        result = bool3d(result, boolSolid4, 1);
        let resultSolid = new BoolSolidT(result);
        return [resultSolid];
    }

    // 生成矩形管弯头
    const generateRectangularElbowEntities = (length: number, width: number, thickness: number, angle: number) => {
        let section = {
            polygonType: '箱形',
            paramIn: {
                b: width / 1000,
                h: length / 1000,
                t_f1: thickness / 1000,
                t_f2: thickness / 1000,
                t_w1: thickness / 1000,
                t_w2: thickness / 1000,
            }
        }
        let polygons: Polygon[] = graphicStore.extraContext.ToolContext.getPolygonBySection(section);
        let bottomFace = polygons[0];
        let axis = new StraightLine();
        let diameter = width > length ? width : length;
        axis.set(new Point(-diameter, 0, 0), new Vector3(0, -1, 0))
        let revolveSolid = new RevolveSolidT(bottomFace, axis, angle);
        return [revolveSolid];
    }

    // 生成矩形管T形三通
    const generateRectangularTTeeEntities = (width1: number, width2: number, shoulder: number, thickness: number) => {
        // 第一个矩形管
        let section = {
            polygonType: '箱形',
            paramIn: {
                b: width1 / 1000,
                h: width1 / 1000,
                t_f1: thickness / 1000,
                t_f2: thickness / 1000,
                t_w1: thickness / 1000,
                t_w2: thickness / 1000,
            }
        }
        let polygons: Polygon[] = graphicStore.extraContext.ToolContext.getPolygonBySection(section);
        let bottomFace = polygons[0];
        bottomFace.rotate(new Point(0, 0, 0), new Vector3(0, 1, 0), Math.PI / 2);
        let solid1 = new ExtrudeSolidT(new Polygon(bottomFace.edges), new Vector3(1, 0, 0), width2 + 2 * shoulder);
        let solid3 = new ExtrudeSolidT(bottomFace.holes[0], new Vector3(1, 0, 0), width2 + 2 * shoulder);
        // 第二个矩形管
        let section2 = {
            polygonType: '箱形',
            paramIn: {
                b: width2 / 1000,
                h: width2 / 1000,
                t_f1: thickness / 1000,
                t_f2: thickness / 1000,
                t_w1: thickness / 1000,
                t_w2: thickness / 1000,
            }
        }
        let polygons2: Polygon[] = graphicStore.extraContext.ToolContext.getPolygonBySection(section2);
        let bottomFace2 = polygons2[0];
        bottomFace2.rotate(new Point(0, 0, 0), new Vector3(0, 1, 0), Math.PI / 2);
        bottomFace2.rotate(new Point(0, 0, 0), new Vector3(0, 0, -1), Math.PI / 2);
        bottomFace2.move(new Vector3(1, 0, 0), shoulder + width2 / 2);
        let solid2 = new ExtrudeSolidT(new Polygon(bottomFace2.edges), new Vector3(0, -1, 0), width1 / 2 + shoulder);
        let solid4 = new ExtrudeSolidT(bottomFace2.holes[0], new Vector3(0, -1, 0), width1 / 2 + shoulder);
        let result = (solid1 as SolidT)._geo.toBoolSolid();
        let boolSolid2 = (solid2 as SolidT)._geo.toBoolSolid();
        let boolSolid3 = (solid3 as SolidT)._geo.toBoolSolid();
        let boolSolid4 = (solid4 as SolidT)._geo.toBoolSolid();
        result = bool3d(result, boolSolid2, 2);
        result = bool3d(result, boolSolid3, 1);
        result = bool3d(result, boolSolid4, 1);
        let resultSolid = new BoolSolidT(result);
        return [resultSolid];
    }

    const generateBlock = (entities, pointList: JointPoint[] = [], materialUuid: string) => {
        let blockT: HvacTunnelConnectT = new HvacTunnelConnectT();
        blockT.isJoint = true
        blockT.setMaterialUuid(materialUuid);
        blockT.setJointPointList(pointList)
        blockT.uuid = ModelUtils.generateUUID();

        blockT.setPosition(new Point(0, 0, 0));
        blockT.setEntities(entities);
        blockT.setNormal(new Vector3(0, 0, 1));
        blockT.setAxisX(new Vector3(1, 0, 0));
        return blockT;
    }

    return (
        <div className="side-bar-main">
            <SideBarTool
                activeBtnList={[]}
            />
            <div className="body">
                <div className="title">
                    接头
                </div>
                <div className="detail structure-beam-panel">
                    <div className="row compact">
                        <div className="label">材料:</div>
                        <Select
                            size='small'
                            className="select-box"
                            placeholder='材料'
                            onChange={onMaterialChange}
                        >
                            {materials.map((item, index) => (
                                <Select.Option key={index} label={item?.name} value={item?.uuid}>
                                    {item?.name || ''}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className="row compact">
                        <div className="label">接头类型:</div>
                        <Select
                            value={type}
                            size='small'
                            className="select-box"
                            placeholder='接头类型'
                            onChange={(value) => { setType(value); console.log(value) }}
                        >
                            {Object.keys(HVAC_CONNECT_TYPE).map((key, index) => (
                                <Select.Option key={index} label={HVAC_CONNECT_TYPE[key]?.label} value={HVAC_CONNECT_TYPE[key]?.value}>
                                    {HVAC_CONNECT_TYPE[key]?.label || ''}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    {(type === HVAC_CONNECT.ROUND_DUCT_ELBOW || type === HVAC_CONNECT.ROUND_DUCT_TTEE
                        || type === HVAC_CONNECT.ROUND_DUCT_YTEE) &&
                        <div className="row compact">
                            <div className="label">管径(mm):</div>
                            <TnInput
                                size='small'
                                value={diameter}
                                className="input-box"
                                placeholder='管径(mm)'
                                onTextChange={(value) => {
                                    if (!isNaN(parseInt(value))) {
                                        setDiameter(parseInt(value));
                                    } else {
                                        if (value == '') {
                                            setDiameter(null);
                                        } else {
                                            setDiameter(0);
                                        }
                                    }
                                }}
                            />
                        </div>}
                    {(type === HVAC_CONNECT.ROUND_DUCT_TTEE || type === HVAC_CONNECT.ROUND_DUCT_YTEE) &&
                        <div className="row compact">
                            <div className="label">管径2(mm):</div>
                            <TnInput
                                size='small'
                                value={diameter2}
                                className="input-box"
                                placeholder='管径2(mm)'
                                onTextChange={(value) => {
                                    if (!isNaN(parseInt(value))) {
                                        setDiameter2(parseInt(value));
                                    } else {
                                        if (value == '') {
                                            setDiameter2(null);
                                        } else {
                                            setDiameter2(0);
                                        }
                                    }
                                }}
                            />
                        </div>}
                    {type !== HVAC_CONNECT.ROUND_DUCT_ELBOW &&
                        <div className="row compact">
                            <div className="label">长度(mm):</div>
                            <TnInput
                                size='small'
                                value={length}
                                className="input-box"
                                placeholder='长度(mm)'
                                onTextChange={(value) => {
                                    if (!isNaN(parseInt(value))) {
                                        setLength(parseInt(value))
                                    } else {
                                        if (value == '') {
                                            setLength(null)
                                        } else {
                                            setLength(0)
                                        }
                                    }
                                }}
                            />
                        </div>}
                    {(type === HVAC_CONNECT.RECTANGULAR_DUCT_ELBOW || type === HVAC_CONNECT.RECTANGULAR_DUCT_TTEE) &&
                        <div className="row compact">
                            <div className="label">宽度(mm):</div>
                            <TnInput
                                size='small'
                                value={width}
                                className="input-box"
                                placeholder='宽度(mm)'
                                onTextChange={(value) => {
                                    if (!isNaN(parseInt(value))) {
                                        setWidth(parseInt(value))
                                    } else {
                                        if (value == '') {
                                            setWidth(null)
                                        } else {
                                            setWidth(0)
                                        }
                                    }
                                }}
                            />
                        </div>}
                    {type === HVAC_CONNECT.RECTANGULAR_DUCT_TTEE &&
                        <div className="row compact">
                            <div className="label">宽度2(mm):</div>
                            <TnInput
                                size='small'
                                value={width2}
                                className="input-box"
                                placeholder='宽度2(mm)'
                                onTextChange={(value) => {
                                    if (!isNaN(parseInt(value))) {
                                        setWidth2(parseInt(value));
                                    } else {
                                        if (value == '') {
                                            setWidth2(null);
                                        } else {
                                            setWidth2(0);
                                        }
                                    }
                                }}
                            />
                        </div>}
                    {(type === HVAC_CONNECT.ROUND_DUCT_ELBOW || type === HVAC_CONNECT.RECTANGULAR_DUCT_ELBOW) &&
                        <div className="row compact">
                            <div className="label">角度(度):</div>
                            <TnInput
                                size='small'
                                value={angle ? ((angle * 180) / Math.PI).toFixed(0) : null}
                                className="input-box"
                                placeholder='角度(度)'
                                onTextChange={(value) => {
                                    if (!isNaN(parseInt(value))) {
                                        let angle = parseInt(value)
                                        while (angle > 360) {
                                            angle -= 360;
                                        }
                                        while (angle < 0) {
                                            angle += 360;
                                        }
                                        angle = (angle * Math.PI) / 180;
                                        setAngle(angle);
                                    } else {
                                        if (value == '') {
                                            setAngle(null);
                                        } else {
                                            setAngle(0);
                                        }
                                    }
                                }}
                            />
                        </div>}
                    <div className="row compact">
                        <div className="label">壁厚(mm):</div>
                        <TnInput
                            size='small'
                            value={thickness}
                            className="input-box"
                            placeholder='壁厚(mm)'
                            onTextChange={(value) => {
                                if (!isNaN(parseInt(value))) {
                                    setThickness(parseInt(value))
                                } else {
                                    if (value == '') {
                                        setThickness(null);
                                    } else {
                                        setThickness(0);
                                    }
                                }
                            }}
                        />
                    </div>
                    <div className='bottom-footer'>
                        <div className="ope-btn">
                            <div className="insert-button" onClick={assemble}>
                                <div className="icon"><AssembleBlackSvg className="icon-svg" /></div>
                                <div className="text">布置</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}